import { render, staticRenderFns } from "./epb-loading.component.vue?vue&type=template&id=276abd4e&scoped=true"
import script from "./epb-loading.component.vue?vue&type=script&lang=ts"
export * from "./epb-loading.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-loading.component.vue?vue&type=style&index=0&id=276abd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276abd4e",
  null
  
)

export default component.exports